export const feedbackBadgeTypes = {
  Poor: {
    label: "• Poor",
    className: "text-[#B42318] bg-[#FEF3F2]",
  },
  Satisfactory: {
    label: "• Satisfactory",
    className: "bg-[#FFFAEB] text-[#B54708]",
  },
  Fair: {
    label: "• Satisfactory",
    className: "bg-[#FFFAEB] text-[#B54708]",
  },
  Improvement: {
    label: "• Needs improvement",
    className: "text-[#B42318] bg-[#FEF3F2]",
  },
  Good: {
    label: "• Good",
    className: "text-[#027A48] bg-[#ECFDF3]",
  },
  Excellent: {
    label: "• Exceptional",
    className: "text-[#027A48] bg-[#ECFDF3]",
  },
};

export type FeedbackBadgeType = keyof typeof feedbackBadgeTypes;

export const feedbackScores: { [key: string]: number } = {
  Poor: 10,
  Satisfactory: 50,
  Good: 85,
  Exceptional: 100,
};

export type OrgDetailsType = {
  inOrg?: boolean;
  accessibleToOrg?: boolean;
  updateAccessibleToOrg?: (accessible: boolean) => void;
};
